import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import type { DialogColor } from './types';

export const getContentCss = ({ color }: { color: DialogColor }) => {
  const paddingTop = color !== 'white' ? 'var(--cds-spacing-300)' : 0;

  return css`
    grid-area: content;
    padding: ${paddingTop} var(--cds-spacing-300) 0 var(--cds-spacing-300);

    ${breakpoints.down('xs')} {
      padding-right: var(--cds-spacing-200);
      padding-left: var(--cds-spacing-200);
    }
  `;
};
